<template>
  <div v-if="marcacao && marcacao.atendimento && marcacao.atendimento.guias">
    <div class="mt-0">
      <br>

      <div v-if="guia_operadora && guia_operadora.ch_imp_guia == 'N' && lista && lista.length > 0" class="alert alert-warning">
        Impressão da guia <strong>NÃO</strong> necessária para essa operadora.
      </div>

      <div v-else-if="guia_operadora && guia_operadora.ch_imp_guia == '1' && lista && lista.length > 0" class="alert alert-info d-flex justify-content-between">
        <div>
          Impressão da guia <strong>SOMENTE DA PRIMEIRA PÁGINA (TOTAL)</strong> para essa operadora.
        </div>
        <div>
          <a href="#" @click.prevent="imprimir_guia_pagina_total()" class="card-link">
            Imprimir
          </a>
        </div>
      </div>

      <div v-else-if="guia_operadora && guia_operadora.ch_imp_guia == 'P' && lista && lista.length > 0" class="alert alert-info d-flex justify-content-between">
        <div>
          Impressão da guia <strong>SOMENTE DA PRIMEIRA PÁGINA</strong> para essa operadora.
        </div>
        <div>
          <a href="#" @click.prevent="imprimir_guias_pagina()" class="card-link">
            Imprimir
          </a>
        </div>
      </div>

      <table class="table table-striped" v-if="lista.length > 0 || tem_valores">
        <thead>
          <tr>
            <th>
              <a href="#" @click.prevent="exibir_itens = !exibir_itens" class="card-link" v-if="lista && lista.length">
                <i class="fa fa-plus-square-o" aria-hidden="true" v-if="!exibir_itens"></i>
                <i class="fa fa-minus-square-o" aria-hidden="true" v-if="exibir_itens"></i>
              </a>
            </th>
            <th>Tipo da Guia</th>
            <th>Número da Guia do Prestador</th>
            <th>
              <span v-if="marcacao.plano && marcacao.plano.operadora.fl_sus">
                Tipo
              </span>
              <span v-else>
                Número da Guia Atribuído pela Operadora
              </span>
            </th>
            <th>Data</th>
            <th>Senha</th>
            <th v-if="!marcacao || !marcacao.block_valores">Valor</th>
            <th class="text-center text-nowrap">
                <button class="btn btn-link py-0 text-primary" type="button" v-if="marcacao.plano && marcacao.plano.operadora.fl_servico_autorizacao" @click="autorizar_guias()" >
                    <big data-toggle="tooltip" data-placement="top" title="Autorizar todas as guias">
                    <i class="fas fa-wifi"></i>
                    </big>
                </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(guia, index) in lista">
            <tr :key="'G' + index" :class="( guia.guia_cancelamento && guia.guia_cancelamento.fl_definitivo ) ? 'table-danger' : ''" v-if="true">
              <td>
                <span class="badge" :class="'badge-' + guia.status_color" data-toggle="tooltip"
                  data-placement="top" :title="guia.status">
                  {{ guia.ch_status }}
                </span>
              </td>
              <td class="text-nowrap">
                <div>
                  {{ guia.nome }}
                  <span class="badge badge-secondary" v-if="guia.ch_status != 'CA' && guia.valor_total">
                    P{{ guia.valor_total.procs }}
                    <span v-if="guia.valor_total.desps">
                      <i class="fa fa-caret-right mx-1" aria-hidden="true"></i>
                      D{{ guia.valor_total.desps }}
                    </span>
                  </span>
                  <i class="fas fa-star-of-life ml-2" v-if="guia.outra" title="Outro atendimento."></i>

                  <i class="fa-regular fa-calendar-star ml-2 text-secondary" v-if="guia.js_datas && guia.js_datas.datas && guia.js_datas.datas.length" title="Datas Listadas"></i>
                </div>
              </td>
              <td>
                <div
                  class="input-group input-group-sm"
                  v-if="
                    (guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS' ) &&
                      guia_operadora &&
                      guia_operadora.fl_editar_guia_prestador
                  "
                >
                  <input
                    class="form form-control"
                    v-model="guia.st_numero_interno"
                    @input="guia.guia_formatada = guia.st_numero_interno"
                  />
                  <div class="input-group-append">
                    <a class="btn btn-outline-secondary" title="Guia Assinada" v-if="guia.assinada" :href="guia.assinada.arquivo.temporary_url" target="_blank">
                        <i class="fa-solid fa-signature"></i>
                    </a>
                  </div>
                </div>
                <span v-else>{{ guia.guia_formatada }}
                    <a class="text-secondary ml-2" title="Guia Assinada" v-if="guia.assinada" :href="guia.assinada.arquivo.temporary_url" target="_blank">
                        <i class="fa-solid fa-signature"></i>
                    </a>
                </span>
              </td>
              <td>
                <div v-if="guia.ch_tipo_guia == 'A'">
                  <az-input
                    sizing="sm"
                    type="select"
                    placeholder="Tipo de APAC..."
                    :edicao="( guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS' )"
                    :optionsList="[
                      { id: 1, search: 'Inicial' },
                      { id: 2, search: 'Continuidade' },
                      { id: 3, search: 'Única' },
                      { id: 4, search: 'Encerramento' },
                    ]"
                    optionsData="id"
                    v-model="guia.in_tipo_apac" />
                </div>

                <div class="input-group input-group-sm"
                  v-else-if="( guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS' ) &&
                      guia_operadora &&
                      guia_operadora.fl_editar_guia_operadora
                    ">
                  <input class="form form-control" v-model="guia.st_numero" />
                </div>

                <span v-else-if="guia.st_numero">{{ guia.st_numero }}</span>
              </td>
              <td>
                <az-input
                  type="date"
                  sizing="sm"
                  :edicao=" ( guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS' ) && marcacao.pode_alterar_data"
                  v-model="guia.data_guia">
                  <template v-slot:button-pre>
                    <div class="input-group-prepend" v-if="guia.data_guia != marcacao.dt_inicio.substr(0,10)">
                      <span class="input-group-text" id="basic-addon1" title="Data da guia diferente da data do atendimento.">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                      </span>
                    </div>
                  </template>
                </az-input>
              </td>
              <td>
                <small>
                  {{ guia.st_codigo_autorizacao }}
                </small>
              </td>
              <td v-if="!marcacao || !marcacao.block_valores">
                <small v-if="guia.ch_status != 'CA'">
                  {{ $util.formatMoeda(guia.valor_total.total) }}
                </small>
              </td>
              <td class="text-right text-nowrap">
                <!-- Autorização OnLine -->
                <template v-if="( guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS') && marcacao.plano && marcacao.plano.operadora.fl_servico_autorizacao">
                  <span class="dropdown">
                    <button class="btn btn-link py-0"
                      :class="( guia.autorizacao && guia.autorizacao.status_solicitacao && guia.autorizacao.status_solicitacao.color ) ? 'text-' + guia.autorizacao.status_solicitacao.color : 'text-secondary'"
                      type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <big data-toggle="tooltip" data-placement="top" title="Autorização Online">
                        <i class="fas fa-wifi"></i>
                      </big>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <div class="dropdown-item text-muted" v-if="guia.autorizacao && guia.autorizacao.status_solicitacao">
                        <span class="badge" :class="'badge-' + guia.autorizacao.status_solicitacao.color">
                          {{ guia.autorizacao.status_solicitacao.msg }}
                        </span>
                      </div>
                      <a class="dropdown-item" href="#" @click.prevent="autorizar(guia)">{{ guia.autorizacao ? 'Re-enviar Autorização' : 'Autorizar Online' }}</a>
                      <div class="dropdown-divider" v-if="guia.autorizacao"></div>
                      <a class="dropdown-item" v-if="guia.autorizacao" href="#" @click.prevent="autorizar_status(guia)">Status</a>
                      <a class="dropdown-item" v-if="guia.autorizacao" href="#" @click.prevent="autorizar_cancelar(guia)">Cancelamento</a>
                      <a class="dropdown-item" v-if="guia.autorizacao" href="#" @click.prevent="autorizar_consultar(guia)">Consultar</a>
                      <a class="dropdown-item" v-if="guia.autorizacao && guia.autorizacao.status_solicitacao" href="#" @click.prevent="autorizar_enviar_documentos(guia)">Enviar Documentos/Anexos</a>
                      <a class="dropdown-item" v-if="guia.autorizacao" href="#" @click.prevent="log_autorizacoes(guia)">Log das autorizaçōes online</a>
                    </div>
                  </span>
                </template>

                <template v-else-if="( guia.ch_status == 'CA' && marcacao.plano.operadora.fl_servico_autorizacao && guia.autorizacao )">
                  <span class="dropdown">
                    <button class="btn btn-link py-0"
                      :class="( guia.autorizacao && guia.autorizacao.status_solicitacao && guia.autorizacao.status_solicitacao.color ) ? 'text-' + guia.autorizacao.status_solicitacao.color : 'text-secondary'"
                      type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <big data-toggle="tooltip" data-placement="top" title="Autorização Online">
                        <i class="fas fa-wifi"></i>
                      </big>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <div class="dropdown-item text-muted" v-if="guia.autorizacao && guia.autorizacao.status_solicitacao">
                        <span class="badge" :class="'badge-' + guia.autorizacao.status_solicitacao.color">
                          {{ guia.autorizacao.status_solicitacao.msg }}
                        </span>
                      </div>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" href="#" @click.prevent="autorizar_status(guia)">Status</a>
                      <a class="dropdown-item" href="#" @click.prevent="autorizar_cancelar(guia)">Cancelamento</a>
                      <a class="dropdown-item" href="#" @click.prevent="autorizar_consultar(guia)">Consultar</a>
                      <a class="dropdown-item" v-if="guia.autorizacao" href="#" @click.prevent="log_autorizacoes(guia)">Log das autorizaçōes online</a>
                    </div>
                  </span>
                </template>

                <template v-else-if="guia.autorizacao && guia.autorizacao.status_solicitacao">
                  <span class="badge" :class="'badge-' + guia.autorizacao.status_solicitacao.color">
                    {{ guia.autorizacao.status_solicitacao.msg }}
                  </span>
                </template>

                <!-- Autorização -->
                <template>
                  <span class="dropdown">
                    <button class="btn btn-link text-dark py-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <big>
                        <i class="fas fa-ellipsis-v"></i>
                      </big>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <template v-if="( guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS' )
                                    && ( guia.ch_tipo_guia == 'A' )
                                    && ( !marcacao.id_solicitacao_autorizacao )">
                        <a class="dropdown-item" href="#" @click.prevent="abrir_processo_autorizacao(guia)">Abrir Processo de Autorização</a>
                        <div class="dropdown-divider"></div>
                      </template>
                      <template v-if="( guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS' )">
                        <a class="dropdown-item" href="#" @click.prevent="autorizar_manual(guia)">Autorização Manual</a>
                        <div class="dropdown-divider"></div>
                      </template>
                      <template v-if="guia.ch_status == 'DI' || guia.ch_status == 'TS'">
                        <a class="dropdown-item" href="#" @click.prevent="imprimirUnica(guia)">Imprimir Guia</a>
                        <a class="dropdown-item" href="#" @click.prevent="imprimirEspelho(guia)">Imprimir Espelho</a>
                        <a class="dropdown-item" href="#" @click.prevent="imprimirBpa(guia)" v-if="guia.ch_tipo_guia == 'B'">Imprimir BPA</a>
                        <div class="dropdown-divider"></div>
                      </template>

                      <template v-if="( guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS' ) && lista.length > 1 && ( is_viterbo || ( marcacao.atendimento.js_info &&  marcacao.atendimento.js_info.datas && marcacao.atendimento.js_info.datas.length ) )">
                        <a class="dropdown-item" href="#" @click.prevent="separar_atendimento(guia)">Separar Atendimento</a>
                        <div class="dropdown-divider"></div>
                      </template>
                      
                      <a class="dropdown-item" href="#" @click.prevent="pendencia(guia)" v-if="guia.ch_status == 'DI' || guia.ch_status == 'PR'">Adicionar Pendência</a>
                      <a class="dropdown-item" href="#" @click.prevent="solucionar(guia)" v-if="guia.ch_status == 'PR'">Solucionar Pendência</a>
                      <a class="dropdown-item" href="#" @click.prevent="regerar(guia)" v-if="guia.ch_status == 'DI' || guia.ch_status == 'TS'">Regerar Guia</a>
                      <a class="dropdown-item" href="#" @click.prevent="cancelar_guia(guia)" v-if="guia.ch_status == 'DI' || guia.ch_status == 'TS'">Cancelar Guia</a>

                      <a class="dropdown-item" href="#" @click.prevent="lancar_outras_datas(guia)" v-if="marcacao && marcacao.atendimento && ( ( marcacao.atendimento.js_info &&  marcacao.atendimento.js_info.datas ) || guia.ch_tipo_guia == 'S' )">Datas (Ass) Atend.</a>
                      <a class="dropdown-item" href="#" @click.prevent="lancar_outras_datas(guia, true)" v-if="guia.ch_tipo_guia == 'S' && ( guia.js_datas || lista.length > 1 )">Datas (Ass) Guia</a>

                      <template v-if="tem_assinar_guia">
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#" @click.prevent="assinar_guia(guia)" v-if="!guia.assinada && guia.ch_status != 'CA'">Assinar Guia</a>
                      </template>

                      <a class="dropdown-item" href="#" @click.prevent="log_guia(guia)">Log</a>
                    </div>
                  </span>
                </template>

                <button
                  type="button"
                  class="btn btn-link text-primary py-0"
                  @click="regerar(guia)"
                  v-if="1 == 0 && guia.ch_status == 'DI'"
                >
                  <big
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Regerar Guia"
                  >
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                  </big>
                </button>

                <button
                  type="button"
                  class="btn btn-link text-primary py-0"
                  @click="pendencia(guia)"
                  v-if="1 == 0 && ( guia.ch_status == 'DI' || guia.ch_status == 'PR' ) "
                >
                  <big
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Adicionar Pendência"
                  >
                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                  </big>
                </button>

                <button
                  type="button"
                  class="btn btn-link text-success py-0"
                  @click="solucionar(guia)"
                  v-if="1 == 0 && guia.ch_status == 'PR'"
                >
                  <big
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Solucionar Pendência"
                  >
                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                  </big>
                </button>
              </td>
            </tr>
            <tr :key="'D' + index" v-if="exibir_itens">
              <td></td>
              <td colspan="7">
                <!-- Datas da Guia -->
                <div class="alert alert-secondary d-flex justify-content-between p-2 mb-2" v-if="guia.js_datas && guia.js_datas.datas && guia.js_datas.datas.length">
                    <div>
                        <i class="fa-regular fa-calendar-star mr-2 text-secondary" title="Datas Listadas"></i>
                        <span class="small">
                            Datas: {{ guia.js_datas.datas.map(item => $util.getFormatDate(item) + ( ( item && item.length > 10 ) ? ' ' + item.slice(11,16) : '' )).join(', ') }}
                        </span>
                    </div>
                    <div>
                        <span class="badge badge-secondary">
                            {{ guia.js_datas.datas.length }}
                        </span>

                        <a href="#" @click.prevent="editar_datas(marcacao, guia)" class="ml-3" title="Editar datas.">
                            <i class="fa-solid fa-pen-to-square"></i>
                        </a>
                    </div>
                </div>

                <!-- Contrato Operadora -->
                <div>
                  Contrato: {{ guia.contrato_operadora ? guia.contrato_operadora.search : '' }}
                  <span class="badge badge-secondary ml-2" v-if="guia.id_contrato_operadora">
                    #{{ guia.id_contrato_operadora }}
                  </span>
                  <button type="button" class="btn btn-link ml-2" @click="recalc_contrato(guia)" :disabled="$store.state.loading" v-if="guia.ch_status == 'DI'">
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
                <div class="small text-muted">
                  {{ lista_itens(guia) }}
                  <div class="mt-3" v-if="exibir_itens && guia.created_at">
                    Criação: {{ $util.getFormatDate(guia.created_at) }} {{ guia.created_at.slice(11,19) }}
                  </div>
                  <div class="mt-3" v-if="exibir_itens && guia.guia_cancelamento && guia.guia_cancelamento.st_motivo">
                    Motivo de Cancelamento: {{ guia.guia_cancelamento.st_motivo }}
                    <span class="ml-1" v-if="guia.guia_cancelamento.usuario">/ {{ guia.guia_cancelamento.usuario.st_login }}</span>
                    <span class="ml-1" v-if="guia.guia_cancelamento.dt_cancelamento">/ {{ $util.getFormatDate(guia.guia_cancelamento.dt_cancelamento) }} {{ guia.guia_cancelamento.dt_cancelamento.slice(11,19) }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div v-else class="alert-primary d-flex justify-content-center mb-3">
        <p class="lead mt-3">Sem Guia Disponível</p>
      </div>

      <div class="alert alert-secondary d-flex justify-content-between" v-if="marcacao && marcacao.atendimento && marcacao.atendimento.js_info && marcacao.atendimento.js_info.datas && marcacao.atendimento.js_info.datas.length">
        <div class="small">
          Datas: {{ marcacao.atendimento.js_info.datas.map(item => $util.getFormatDate(item) + ( ( item && item.length > 10 ) ? ' ' + item.slice(11,16) : '' )).join(', ') }}
        </div>
        <div>
          <span class="badge badge-secondary">
            {{ marcacao.atendimento.js_info.datas.length }}
          </span>

          <a href="#" @click.prevent="editar_datas(marcacao)" class="ml-3" title="Editar datas.">
            <i class="fa-solid fa-pen-to-square"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="mb-3" v-if="marcacao && marcacao.atendimento && tem_reembolso">

      <div class="d-flex">

        <div v-if="marcacao && marcacao.atendimento && tem_reembolso">
          <az-input
            type="select"
            placeholder="Condição de Reembolso..."
            :optionsList="[
              { id: 0, search: 'Sem Reembolso' },
              { id: 1, search: 'Reembolso para o Atendimento' },
              { id: 2, search: 'Reembolso para a Guia' },
              { id: 3, search: 'Reembolso para a Guia (com Pagamento)' },
            ]"
            optionsData="id"
            :edicao="podeEditarReembolso"
            v-model="marcacao.atendimento.fl_reembolso"
            @input="verificar_pagamento()" />
        </div>

        <div>
          <button type="button" class="btn ml-3" :class="marcacao.credenciais ? 'btn-primary': 'btn-outline-primary'" v-if="marcacao.atendimento.fl_reembolso" @click="obter_credenciais_reembolso()">
            <i class="fas fa-key mr-2"></i>
            Obter Credenciais
          </button>
        </div>

      </div>

      <outro-responsavel-financeiro
        :validate="validate"
        v-if="marcacao.atendimento.fl_reembolso && marcacao.atendimento.pagamento_atendimento"
        :notas="listaNf"
        v-model="marcacao.atendimento" />

    </div>

    <div v-if="marcacao && marcacao.atendimento && tem_reembolso">
      <!-- Notas Fiscais atendimento -->
      <template
          v-if="
              marcacao &&
                  marcacao.unidade_operacao &&
                  marcacao.unidade_operacao.fl_nota_fiscal &&
                  marcacao.atendimento.fl_reembolso && 
                  marcacao.atendimento.fl_reembolso != 3
          "
      >
          <button
              v-if="marcacao.atendimento.fl_reembolso != 2"
              class="btn btn-outline-primary mb-2"
              @click.prevent="gerarNF()"
              :disabled="$store.state.loading"
          >
              {{ (listaNf && listaNf.length == 0 ) ? 'Emitir Nota Fiscal' : 'Regerar Nota Fiscal' }}
          </button>

          <template v-else>
            <!-- Nota fiscal para guia -->
            <div class="dropdown">
                <button
                    class="btn btn-outline-primary mb-2 dropdown-toggle"
                    :disabled="$store.state.loading"
                    id="dropdownMenuButtonNFGuia" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                >
                    {{ (listaNf && listaNf.length == 0 ) ? 'Emitir Nota Fiscal para:' : 'Regerar Nota Fiscal para:' }}
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonNFGuia">
                    <template v-for="(guia, index) in lista">
                        <a :key="index" v-if="guia.ch_status != 'CA'" class="dropdown-item" href="#" @click.prevent="gerarNFGuia(guia)">
                            {{ 'Guia: ' }} <strong>{{ guia.nome + ', ' + guia.st_numero_interno }}</strong>
                        </a>
                    </template>
                </div>
            </div>
          </template>

          <template v-if="possuiNF  && (listaNf && listaNf.length > 0 )">
              <az-sub-title title="Notas fiscais" />

              <div class="list-group mb-3">
                  <div
                      class="list-group-item d-flex"
                      v-for="(nfl, idx) in listaNf"
                      :key="idx"
                  >
                      <span class="mr-3" v-if="nfl.guia">Guia: <strong>{{ nfl.guia }}</strong></span>
                      <span class="mr-3">{{ $util.getFormatDate(nfl.nota_fiscal_servico.dt_emissao) }}</span>
                      <span class="mr-3 text-warning" v-if="nfl.nota_fiscal_servico.dt_competencia && !is_mes_atual(nfl.nota_fiscal_servico)">{{ $util.getFormatDate(nfl.nota_fiscal_servico.dt_competencia, "MM/YYYY", false)}}</span>
                      <span class="mr-3">{{ nfl.nota_fiscal_servico.numero_completo }}</span>
                      <span class="mr-3" v-if="nfl.nota_fiscal_servico.st_numero != nfl.nota_fiscal_servico.st_numero_nf && nfl.nota_fiscal_servico.st_numero_nf">RPS: {{ nfl.nota_fiscal_servico.st_numero }}</span>
                      <span class="mr-3">{{ nfl.nota_fiscal_servico.st_tomador_nome }}</span>
                      <span class="mr-3" v-if="nfl.nota_fiscal_servico.unidade_operacao">
                        <span class="badge badge-dark" title="Unidade Emissora da Nota Fiscal">
                          {{ nfl.nota_fiscal_servico.unidade_operacao.st_sigla
                            ? nfl.nota_fiscal_servico.unidade_operacao.st_sigla
                            : nfl.nota_fiscal_servico.unidade_operacao.st_nome }}
                        </span>
                      </span>

                      <span class="mr-3" v-if="nfl.nota_fiscal_servico.dc_valor_servicos">
                        {{ $util.formatMoeda(nfl.nota_fiscal_servico.dc_valor_servicos) }}
                      </span>

                      <span
                          class="mr-3"
                          :class="
                              getStatusClass(
                                  nfl.nota_fiscal_servico.ch_status
                              )
                          "
                          >{{
                              nfl.nota_fiscal_servico.descricao_status
                          }}</span
                      >
                      <span
                          class="mr-3"
                          v-if="
                              marcacao &&
                                  marcacao.unidade_operacao &&
                                  marcacao.unidade_operacao
                                      .fl_nota_fiscal_eletronica
                          "
                      >
                          <nota-fiscal-status
                              :exibirEditar="false"
                              :notaFiscal="nfl.nota_fiscal_servico"
                              @refresh="reload()"
                              @integrar="integrar()"
                          />
                      </span>
                  </div>
              </div>
          </template>
      </template>
    </div>

    <!-- Espelho do Atendimento -->
    <div class="d-flex" v-if="marcacao">
      <div v-if="marcacao.atendimento.guias.length > 0 || tem_valores">
        <button type="button" class="btn btn-outline-primary mb-1" @click="regerar()">
          Regerar Guias
        </button>
      </div>

      <autoriz-online ref="autoriz" @refresh="reload()" />

      <div class="ml-2" v-if="$route.path == '/recepcao'" @click="incluir_outro_atendimento(marcacao)">
        <button type="button" class="btn btn-outline-primary mb-1">
          <i class="fa fa-plus mr-2" aria-hidden="true"></i>
          Outro Atendimento
        </button>
      </div>

      <div>
        <span class="dropdown ml-2 mb-1" v-if="marcacao && marcacao.arquivos" title="Anexos" :hide_content_while_loading="true">
            <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa-solid fa-paperclip"></i>

                <span class="badge badge-primary ml-1" v-if="marcacao.arquivos && marcacao.arquivos.length > 0">
                    {{ marcacao.arquivos.length }}
                </span>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a href="#" @click.prevent="abrir_anexar_arquivo()" class="dropdown-item" v-if="marcacao && marcacao.arquivos"> 
                    <i class="fa-solid fa-plus fa-fw mr-2" v-if="!marcacao.arquivos.length"></i>
                    <i class="fa-solid fa-paperclip fa-fw mr-2" v-else></i>
                    Atendimento

                    <span v-if="marcacao.arquivos.length" class="badge badge-primary ml-2">
                        {{ marcacao.arquivos.length }}
                    </span>
                </a>

                <a href="#" @click.prevent="abrir_anexar_arquivo(true)" class="dropdown-item" v-if="marcacao.paciente && marcacao.paciente.arquivos"> 
                    <i class="fa-solid fa-plus fa-fw mr-2" v-if="!marcacao.paciente.arquivos.length"></i>
                    <i class="fa-solid fa-paperclip fa-fw mr-2" v-else></i>
                    Paciente

                    <span v-if="marcacao.paciente.arquivos.length" class="badge badge-primary ml-2">
                        {{ marcacao.paciente.arquivos.length }}
                    </span>
                </a>
            </div>
        </span>

        <button type="button" class="btn btn-outline-primary ml-2 mb-1" @click="abrir_anexar_arquivo()" v-if="false">
          <i class="fa-solid fa-paperclip"></i>
          <span class="badge badge-primary ml-1" v-if="marcacao.arquivos && marcacao.arquivos.length > 0">
            {{ marcacao.arquivos.length }}
          </span>
        </button>
      </div>

      <laboratorio-etiqueta ref="labetq" :fila="true" v-model="marcacao" />
      <pacs-status class="ml-2" ref="pacsStatus" @refresh="reload()"  :atendimento="marcacao.atendimento" v-if="exibirPacsStatus(marcacao)"/>

      <div class="ml-2" v-if="existeConsultaESadt">
        <button type="button" class="btn btn-outline-primary mb-1" @click="imprimirConsulta()">
          Imprimir guia de consulta
        </button>
      </div>

      <div class="ml-2" v-if="existeConsultaESadt">
        <button type="button" class="btn btn-outline-primary mb-1" @click="imprimirOutras()">
          Imprimir outras guias
        </button>
      </div>

      <az-input
        class="ml-2"
        type="checkbox-group"
        :label="'Exibir Guias Canceladas (' + total_canceladas + ')'"
        v-if="total_canceladas"
        v-model="exibir_canceladas" />

      <div id="print-espelho-atendimento" class="d-none d-print-block">
        <espelho-atendimento :dados="marcacao" :prazo="exibir_prazo" :sem_valor="espelho_sem_valor" :id_guia="id_guia_espelho" :detalhe_despesas="espelho_detalhe_despesa" />
      </div>

      <div class="ml-2">
        <print-export ref="print_espelho" printid="print-espelho-atendimento" :icon="false" @afterprint="id_guia_espelho = null">
          <template v-slot:botao>
            <span>Espelho do Atendimento</span>
          </template>

          <template v-slot:dropdownitem>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click="toggle_exibir_valores()">
              <i class="fas fa-eye-slash fa-fw mr-2" v-if="espelho_sem_valor"></i>
              <i class="fas fa-eye fa-fw mr-2" v-else></i>
              Exibir Valores
            </a>
            <a class="dropdown-item" href="#" @click="toggle_exibir_despesas()" v-if="!espelho_sem_valor">
              <i class="fas fa-eye-slash fa-fw mr-2" v-if="!espelho_detalhe_despesa"></i>
              <i class="fas fa-eye fa-fw mr-2" v-else></i>
              Exibir Despesas Detalhadas
            </a>

            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click="enviar_espelho()">
                <i class="far fa-envelope-open fa-fw mr-2"></i>
                Enviar
            </a>
            <a class="dropdown-item" href="#" @click="printEtiqueta()">
                <i class="fa fa-tags fa-fw mr-2" aria-hidden="true"></i>
                Emitir Etiqueta
            </a>
            
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click="imprimir_guia_pagina_total()" v-if="lista && lista.length > 1">
              <i class="fa fa-print fa-fw mr-2" aria-hidden="true"></i>
              Imprimir Guia 1 Página Total
            </a>
            <a class="dropdown-item" href="#" @click="imprimir_guias_pagina()">
              <i class="fa fa-print fa-fw mr-2" aria-hidden="true"></i>
              {{ lista && lista.length > 1 ? 'Imprimir Guias' : 'Imprimir Guia' }}
              Primeira Página
            </a>
          </template>
        </print-export>
      </div>

      <div class="ml-2" v-if="unificar">
        <button type="button" class="btn btn-outline-secondary mb-1" @click="unificar_guias()">
          Unificar Guias
        </button>
      </div>


    </div>

    <outras-marcacoes class="mt-3" :dados="marcacao" @reabrir="reabrir" :pode_encaminhar="true" @encaminhar="$emit('encaminhar', $event)" />

    <exibir-lab-logins :marcacao="marcacao" :exibir_prazo="true" />

    <!-- Autorização de Guia Manual -->
    <autorizar-guia-manual ref="aut_manual" :marcacao="marcacao" @refresh="reload()" />

    <!-- Documentos para Impressão -->
    <doc-print-atendimento class="mt-3" :marcacao="marcacao" v-if="exibir_docs" />

    <br><br><br>

    <!-- <Visualizacao ref="viewGuias" /> -->
    <!-- <button @click="abrirModal">Nao Clique Aqui!!</button> -->
    <Visualizacao
      :marcacao="marcacao"
      :guias="guias"
      :logo_url="logo_url"
      :nome_contratado_ass="nome_contratado_ass"
      ref="vis"
    />

    <guia-motivo-glosa
      ref="motivoglosa"
      status="PR"
      v-model="guia_selecionada"
      @refresh="reload()"
      :unica="true"
    ></guia-motivo-glosa>

    <!-- Modal -->
    <div
      class="modal fade"
      id="cancelarGuiaModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="guia_a_cancelar">
          <div class="modal-header">
            <h5 class="modal-title">Cancelar Guia</h5>
            <button
              type="button"
              class="close"
              @click="fechar_modal_cancelar_guia()"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Cancelar Guia {{ guia_a_cancelar.nome }}, No.
            {{ guia_a_cancelar.guia_formatada }}

            <div class="row">
              <div class="col">
                <az-input
                  type="textarea"
                  label="Motivo"
                  v-model="motivo"
                  :validate="validate"
                  required />
              </div>
            </div>

            <div class="row mt-3">
              <div class="col">
                <az-input
                  type="checkbox-group"
                  label="Cancelamento Definitivo"
                  v-model="definitivo"
                  :validate="validate" />
              </div>
            </div>

            <p class="alert alert-secondary mt-3 mb-0">
              <i class="fas fa-info-circle mr-2"></i>
              O cancelamento definitivo deve ser realizado se o procedimento não mais será faturado em outra guia.
            </p>

          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="fechar_modal_cancelar_guia()"
            >
              Fechar
            </button>
            <az-submit color="danger" @click="confirmar_cancelar_guia()"
              >Confirmar</az-submit
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Unificar Guias -->
    <div
      class="modal fade"
      id="unificarGuiasModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div class="modal-content" v-if="guias_para_unificar && guias_para_unificar.length > 0">
          <div class="modal-header">
            <h5 class="modal-title">Unificar Guias</h5>
            <button
              type="button"
              class="close"
              @click="fechar_modal_unificar_guia()"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="row">
              <div class="col">
                <az-input
                  label="Número da guia na operadora"
                  v-model="unificar_numero_guia"
                  :validate="validate"
                  />
              </div>
            </div>

            <table class="table table-striped mt-2">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Status</th>
                  <th scope="col">Guia</th>
                  <th scope="col">Senha</th>
                  <th scope="col">Procedimentos</th>
                  <th scope="col">Contrato</th>
                  <th scope="col" v-if="!marcacao || !marcacao.block_valores">Valor</th>
                </tr>
              </thead>
              <template v-for="(item, index) in guias_para_unificar">
                <tr :key="'UNIF' + index" v-if="true">
                  <td>
                    <input type="checkbox" v-model="item.check">
                  </td>
                  <td>
                    <span class="badge" :class="'badge-' + item.guia.status_color" data-toggle="tooltip"
                      data-placement="top" :title="item.guia.status">
                      {{ item.guia.ch_status }}
                    </span>
                  </td>
                  <td>
                    {{ item.guia.guia_formatada }}
                  </td>
                  <td>
                    {{ item.guia.st_codigo_autorizacao }}
                  </td>
                  <td class="small text-muted">
                    {{ lista_itens(item.guia) }}
                  </td>
                  <td class="small">
                    <template v-if="item.guia.contrato_operadora">
                        {{ item.guia.contrato_operadora.search }}
                    </template>
                  </td>
                  <td v-if="!marcacao || !marcacao.block_valores">
                    <small>
                      {{ $util.formatMoeda(item.guia.valor_total.total) }}
                    </small>
                  </td>
                </tr>
              </template>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="fechar_modal_unificar_guia()"
            >
              Fechar
            </button>
            <az-submit color="primary" @click="confirmar_unificar_guias()"
              >Confirmar</az-submit
            >
          </div>
        </div>
      </div>
    </div>



    <reembolso-obter-credenciais ref="cred" />

    <!-- Dispatch -->
    <az-dispatch ref="dispatchModal" titulo="Autorizar todas as guias" @refresh="reload()" />

    <!-- Anexos -->
    <template v-if="acao_anexar">
        <az-file-upload
            ref="upload"
            @refresh="carregar_arquivos(false, anexar_pacientes)"
            :multiple="true"
            :arquivos="anexar_pacientes ? marcacao.paciente.arquivos : marcacao.arquivos"
            :parms="{ 
                model_type: anexar_pacientes ? 'pessoa' : 'marcacao', 
                model_id: anexar_pacientes ? marcacao.id_paciente : marcacao.id_marcacao, 
                id_paciente: marcacao.id_paciente ? marcacao.id_paciente : marcacao.id_pessoa,
            }" />
    </template>

    <log-solicitacao-autorizacao ref="logSolicAutorizacao"/>

    <procedimento-outras-datas 
        ref="outras_datas" 
        :id_medico="-1" 
        :pode_vazio="true" 
        :pode_livre="true" 
        v-if="marcacao" 
        @lancar="gerar_outras_datas" 
        @livres="editar_datas(marcacao, guia_edicao_data)" />

    <editar-datas-marcacao 
        ref="editar_datas" 
        @refresh="reload()" 
        @lancar="gerar_outras_datas" />

    <!-- Emitir Etiqueta -->
    <emitir-etiqueta ref="etiqueta" sufixo="guiatiss" />
  </div>
</template>

<script>
import * as moment from "moment";
import $ from "jquery";
import _ from "lodash";
import GuiaMotivoGlosa from "./GuiaMotivoGlosa.vue";
import Visualizacao from "./VisualizacaoGuia.vue";
import AzInput from "../shared/forms/AzInput.vue";
import AzSubmit from "../util/AzSubmit.vue";
import OutrasMarcacoes from "../modulos/recepcao/OutrasMarcacoes.vue";
import PrintExport from "../shared/PrintExport.vue";
import EspelhoAtendimento from "../modulos/recepcao/EspelhoAtendimento.vue";
import AutorizOnline from "../modulos/autoriz/AutorizOnline.vue";
import AutorizarGuiaManual from './AutorizarGuiaManual.vue';
import LaboratorioEtiqueta from '../modulos/recepcao/LaboratorioEtiqueta.vue';
import DocPrintAtendimento from '../modulos/recepcao/DocPrintAtendimento.vue';
import ReembolsoObterCredenciais from '../modulos/recepcao/ReembolsoObterCredenciais.vue';
import NotaFiscalStatus from "../modulos/financeiro/NotaFiscalStatus.vue";
import AzSubTitle from '../util/AzSubTitle.vue';
import ExibirLabLogins from '../modulos/recepcao/ExibirLabLogins.vue';
import OutroResponsavelFinanceiro from '../modulos/recepcao/OutroResponsavelFinanceiro.vue';
import AzDispatch from "../util/AzDispatch.vue";
import AzFileUpload from '../util/AzFileUpload.vue';
import PacsStatus from "../../components/shared/PacsStatus.vue";
import LogSolicitacaoAutorizacao from "../shared/audit/LogSolicitacaoAutorizacao.vue";
import ProcedimentoOutrasDatas from '../modulos/recepcao/ProcedimentoOutrasDatas.vue';
import EditarDatasMarcacao from './EditarDatasMarcacao.vue';
import EmitirEtiqueta from '../shared/EmitirEtiqueta.vue';
// import { forEach } from "csv-string";

export default {
  data() {
    return {
      guia_selecionada: null,
      guias: [],
      logo_url: "",
      guia_a_cancelar: null,
      motivo: "",
      definitivo: false,
      validate: false,
      guia_operadora: null,
      exibir_canceladas: false,
      nome_contratado_ass: false,
      exibir_prazo: false,
      exibir_itens: false,
      docs_sem_login: false, 
      tem_reembolso: false,
      espelho_sem_valor: false,
      espelho_detalhe_despesa: false, 
      id_guia_espelho: null, 
      acao_anexar: false,
      unificar: false,
      guias_para_unificar: null,
      unificar_numero_guia: '',
      pode_imp_guias: true, 
      anexar_pacientes: false, 
    };
  },

  components: {
    GuiaMotivoGlosa,
    Visualizacao,
    AzInput,
    AzSubmit,
    OutrasMarcacoes,
    PrintExport,
    EspelhoAtendimento,
    AutorizOnline,
    AutorizarGuiaManual,
    LaboratorioEtiqueta,
    DocPrintAtendimento,
    ReembolsoObterCredenciais,
    NotaFiscalStatus,
    AzSubTitle,
    ExibirLabLogins,
    OutroResponsavelFinanceiro,
    AzDispatch,
    AzFileUpload, 
    PacsStatus,
    LogSolicitacaoAutorizacao,
    ProcedimentoOutrasDatas,
    EditarDatasMarcacao, 
    EmitirEtiqueta, 
  },

  props: ["marcacao", "tem_assinar_guia"],

  computed: {

    is_viterbo: function () { 
        return window.redir == 'viterbo';
    },

    exibir_docs: function () { 
        if ( !this.docs_sem_login ) 
            return true; 

        if ( !this.marcacao || !this.marcacao.terceiro_logins || !this.marcacao.terceiro_logins.length )
            return false;

        return true;
    },  

    tem_valores: function () { 
      if ( !this.marcacao || !this.marcacao.atendimento || !this.marcacao.atendimento.atendimento_procedimentos )
        return false;

      return this.marcacao.atendimento.atendimento_procedimentos.find(item => item.cd_valor_total > 0 
            || ( item.atendimento_pacote && item.atendimento_pacote.id_atendimento == item.id_atendimento )
        ) 
        ? true 
        : false;
    },

    possuiNF: function() {
        const nfLinks = _.get(
            this.marcacao,
            "atendimento.nota_fiscal_links"
        );
        const possuiNFAtendimento = (
            nfLinks != undefined &&
            Array.isArray(nfLinks) &&
            nfLinks.length > 0
        );

        let possuiNFGuias = false;
        if(this.marcacao && this.marcacao.atendimento && this.marcacao.atendimento.guias) {
            this.marcacao.atendimento.guias.filter(guia => guia.ch_status != 'CA').forEach((guia) => {
                const nfLinksGuia = _.get(
                    guia,
                    "nota_fiscal_links"
                );
                possuiNFGuias = possuiNFGuias || (
                    nfLinksGuia != undefined &&
                    Array.isArray(nfLinksGuia) &&
                    nfLinksGuia.length > 0
                );
            });
        }

        return possuiNFAtendimento || possuiNFGuias;
    },

    listaNf: function() {
        if (!this.possuiNF) return [];

        if(this.marcacao && this.marcacao.atendimento && this.marcacao.atendimento.fl_reembolso && ( this.marcacao.atendimento.fl_reembolso == 2 || this.marcacao.atendimento.fl_reembolso == 3 ) ) {
            if(!this.marcacao.atendimento.guias) return [];

            let nfsLinks = [];
            this.marcacao.atendimento.guias.filter(guia => guia.ch_status != 'CA').forEach((guia) => {
                if(guia.nota_fiscal_links) {
                    let links = guia.nota_fiscal_links;
                    for (let i = 0; i < links.length; i++) {
                        links[i].guia = guia.st_numero_interno;
                    }

                    nfsLinks.push(...links);
                }
            });

            return nfsLinks;
        }

        return this.marcacao.atendimento.nota_fiscal_links;
    },

    podeEditResponsavelFinanceiro: function() {

        return false;
    },

    podeEditarReembolso: function() {
      if ( !this.marcacao.atendimento.contatos )
        return false;

      const possuiNF = this.possuiNF;
      const podeEmitirNF = this.marcacao && this.marcacao.unidade_operacao && this.marcacao.unidade_operacao.fl_nota_fiscal;

      const temContatos = ( this.marcacao.atendimento.contatos.length
        ||  this.marcacao.atendimento.guias.filter(guia => guia.ch_status != 'CA'
                && guia.atendimento_procedimento_guias.length
                && guia.contatos
                && guia.contatos.length).length )
        ? true
        : false;

      return (!podeEmitirNF || (podeEmitirNF && !possuiNF)) && !temContatos;
    },

    lista: function () {
      if ( !this.marcacao )
        return [];

      let lista = this.marcacao.atendimento.guias.filter(item =>
        (
          this.exibir_canceladas
          || ( item.ch_status != 'CA' && ( ( _.get(item, 'valor_total.procs', 0) + _.get(item, 'valor_total.desps', 0) ) > 0 ) )
          || ( item.guia_cancelamento && item.guia_cancelamento.fl_definitivo )
        ) );

      if ( this.marcacao.outras ) {
        let outras = this.marcacao.outras.filter(item => item.id_marcacao != this.marcacao.id_marcacao
          && item.atendimento && item.atendimento.guias)
          .flatMap(item => item.atendimento.guias)
          .filter(item =>
            this.exibir_canceladas
            || ( item.ch_status != 'CA' && ( ( _.get(item, 'valor_total.procs', 0) + _.get(item, 'valor_total.desps', 0) ) > 0 ) )
            || ( item.guia_cancelamento && item.guia_cancelamento.fl_definitivo ) )
          .map(item => {
            item.outra = true;
            return item;
          });

        lista = lista.concat(outras);
      }

      return lista;

    },

    total_canceladas: function () {
      if ( !this.marcacao )
        return 0;

      return this.marcacao.atendimento.guias.filter(item => item.ch_status == 'CA'
        || ( ( _.get(item, 'valor_total.procs', 0) + _.get(item, 'valor_total.desps', 0) ) == 0 ) ).length;
    },

    existeConsultaESadt: function () {
      return this.marcacao.atendimento.guias.find(
            (item) =>
                item.ch_status != 'CA' &&
              (item.nome == "SP/SADT" || item.nome == "Honorário Individual"))
          &&
          this.marcacao.atendimento.guias.find(
            (item) =>
                item.ch_status != 'CA' &&
                item.nome == "Consulta");
    },

  },

  methods: {
    assinar_guia (guia) { 
        this.$parent.assinar_guias(guia.id_guia);
    },

    printEtiqueta () {
      this.$refs.etiqueta.emitir('marcacao', this.marcacao);
    },

    unificar_guias() { 
      if( !this.marcacao || !this.marcacao.atendimento || !this.marcacao.atendimento.guias )
        return;

      this.guias_para_unificar = this.marcacao.atendimento.guias
                .filter(guia => guia.ch_status == 'DI' && guia.nome == 'SP/SADT' && (guia.valor_total && guia.valor_total.total > 0))
        .map(guia => {
          return {
            guia: {...guia},
            check: false,
          }
        });

      if ( !this.guias_para_unificar || this.guias_para_unificar.length <= 1 ) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Não há guias SP/SADT para unificar",
          life: 3000
        });
        return;
      }
        
      $("#unificarGuiasModal").modal("show");
    },

    confirmar_unificar_guias() {
      console.log('guias_para_unificar', this.guias_para_unificar);

      if ( this.guias_para_unificar.filter(guia => guia.check).length <= 1 ) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Selecione mais de uma guia para unificar",
          life: 3000
        });
        return;
      }

      this.$util.atualizar(this, {
        service: 'solicitacao_autorizacoes',
        func: 'unificar_guias',
        dados: {
          numero_guia_operadora: this.unificar_numero_guia,
          id_guias: this.guias_para_unificar.filter(guia => guia.check).map(guia => guia.guia.id_guia),
        },
        toast: true,
        callback: () => {
          this.fechar_modal_unificar_guia();
          this.reload();
        }
      });
    },

    fechar_modal_unificar_guia() {
      this.guias_para_unificar = null;
      $("#unificarGuiasModal").modal("show");
    },

    separar_atendimento(guia) { 
        if ( !confirm('Confirma separar o atendimento dessa guia? Essa ação é irreversível.') ) { 
          return;
        }

        this.$util.atualizar(this, {
          service: 'guias',
          func: 'separar_atendimento',
          dados: {
            id_guia: guia.id_guia,
          },
          toast: true,
          callback: () => {
            this.reload();
          }
        });
    },

    editar_datas (marcacao, guia = null) { 
        this.guia_edicao_data = guia;
        this.$refs.editar_datas.abrir(marcacao, guia);
    },

    incluir_outro_atendimento (marcacao) { 
      let novo = _.cloneDeep(marcacao);

      novo.id_medico = null;
      novo.medico = null;

      novo.id_procedimento = null;
      novo.procedimento = null;

      this.$emit('novo', novo);
    },

    // Datas

    gerar_outras_datas (datas) { 
      this.$util.atualizar(this, { 
        service: 'atendimentos', 
        func: 'set_guia_datas', 
        dados: { 
          id_atendimento: this.marcacao.id_atendimento, 
          id_guia: this.guia_edicao_data ? this.guia_edicao_data.id_guia : null,
          datas: datas, 
        },
        toast: true,
        callback: () => {
          this.reload();
        }
      });
    },

    lancar_outras_datas (guia = null, por_guia = false) { 

        if ( guia && por_guia ) { 
            this.guia_edicao_data = guia; 
        } else { 
            this.guia_edicao_data = null; 
        }

        this.$refs.outras_datas.abrir(
            this.marcacao.dt_inicio.slice(0,10), 
            this.$util.agora()
        );

    },

    //

    exibirPacsStatus(marc) {
      if (marc && marc.atendimento && marc.atendimento.atendimento_procedimentos) {
        return marc.atendimento.atendimento_procedimentos.find(
            (proc) => proc.st_pacs == 'OK' || proc.st_an || ( proc.procedimento && proc.procedimento.id_modalidade_dicom )
        );
      }
      
      return false;
    },

    abrir_anexar_arquivo(paciente = false) {
      this.acao_anexar = true;
      this.anexar_pacientes = paciente;
      this.carregar_arquivos(true, paciente);
    },

    carregar_arquivos (abrir = false, paciente = false) {

      this.$store.commit('loading', true);

      if ( !paciente && this.marcacao.id_marcacao ) { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_marcacao,
            type: 'marcacao',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });

      } else { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_pessoa ? this.marcacao.id_pessoa : this.marcacao.id_paciente,
            type: 'pessoa',
          }
        })
        .then(res => {
          this.marcacao.paciente.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });


      }

    },

    imprimir_guias_pagina (obter_callback = false) { 
      this.$refs.vis.imprimirOutras(null, true, false, obter_callback);
    },

    imprimir_guia_pagina_total (obter_callback = false) { 
      let guia = _.cloneDeep(
        _.first(this.lista)
      );

      if ( guia ) { 
        return this.imprimirUnica(guia, true, true, obter_callback);
      } else { 
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Não há guias para impressão",
          life: 3000
        });
      }
    },

    imprimirEspelho (guia) { 
      this.id_guia_espelho = guia.id_guia; 
      this.$refs.print_espelho.imprimir();
    },

    abrir_processo_autorizacao () {
      if ( !confirm('Confirma abrir o processo de autorização?') )
        return;

      this.$util.atualizar(this, {
        service: 'solicitacao_autorizacoes',
        func: 'solicitacao_procedimentos',
        dados: {
          id_marcacao: this.marcacao.id_marcacao,
          block_comunicar: true,
        },
        toast: true,
        callback: () => {
          this.reload();
        }
      });
    },

    is_mes_atual(nf) {
        if(nf && nf.dt_competencia) {
            const competencia = moment(nf.dt_competencia, "YYYY-MM-DD");
            const hj = moment();

            return competencia.month() == hj.month();
        }

        return true;
    },
    verificar_pagamento()  {
      if ( !this.marcacao.atendimento.pagamento_atendimento ) {
        this.marcacao.atendimento.pagamento_atendimento = {
          st_responsavel_financeiro: "",
          st_cpf_cnpj: "",
          st_endereco: "",
          st_email: "",
        };
      }
    },

    toggle_exibir_valores () {
      this.espelho_sem_valor = !this.espelho_sem_valor;

      this.$util.setCookie('esv', this.espelho_sem_valor ? 'S' : 'N');
    },

    toggle_exibir_despesas() { 
      this.espelho_detalhe_despesa = !this.espelho_detalhe_despesa;

      this.$util.setCookie('esd', this.espelho_detalhe_despesa ? 'S' : 'N');
    },

    integrar() {
      if ( !this.marcacao || !this.marcacao.st_id_externo )
        return;

      this.$toast.add({
        severity: "info",
        summary: "Atenção",
        detail: "Integrando...",
        life: 3000
      });

      this.$refs.labetq.abrir();
    },

    enviar_espelho: function () {
      this.$util.atualizar(this, {
        service: 'marcacoes',
        func: 'enviar_espelho',
        dados: {
          id_atendimento: this.marcacao.id_atendimento,
        },
        callback: res => { 
          if ( res.msg ) { 
            this.$toast.add({ 
              severity: "success",
              summary: "Atenção",
              detail: res.msg,
              life: 3000 
            })
          }
        }
      });
    },

    gerarNFGuia: function(guia) {
      if (!confirm("Deseja realmente gerar a Nota Fiscal de Serviço?"))
        return;

      this.$util.atualizar(this, {
        service: "guias",
        func: "set_numero_atribuido",
        dados: {
          guias: this.lista,
          id_atendimento: this.marcacao.atendimento.id_atendimento,
          fl_reembolso: this.marcacao.atendimento.fl_reembolso,
          pagamento_atendimento: this.marcacao.atendimento.pagamento_atendimento,
        },
        callback: pa => {
          if ( pa ) {
            this.$emit('atualizar_progresso', pa);
          }

          this.$nextTick(() => {
            this.$util.atualizar(this, {
              service: "nota_fiscal_servico",
              func: "gerar_nf_guia",
              redir_api: true, 
              toast: true,
              dados: {
                id_guia: guia.id_guia,
              },
              callback: () => {
                this.reload();
              }
            });
          });
        }
      });
    },

    gerarNF: function() {
        if (!confirm("Deseja realmente gerar a Nota Fiscal de Serviço?"))
            return;

        this.$util.atualizar(this, {
        service: "guias",
        func: "set_numero_atribuido",
        redir_api: true, 
        dados: {
          guias: this.lista,
          id_atendimento: this.marcacao.atendimento.id_atendimento,
          fl_reembolso: this.marcacao.atendimento.fl_reembolso,
          pagamento_atendimento: this.marcacao.atendimento.pagamento_atendimento,
        },
        callback: pa => {
          if ( pa ) {
            this.$emit('atualizar_progresso', pa);
          }

          this.$nextTick(() => {
            this.$util.atualizar(this, {
              service: "nota_fiscal_servico",
              func: "gerar_nf_atendimento",
              redir_api: true,
              toast: true, 
              dados: {
                  id_atendimento: this.marcacao.atendimento.id_atendimento,
              },
              callback: () => {
                this.reload();
              }
            });
          });
        }
      });
    },
    getStatusClass: function(status) {
        switch (status) {
            case "1":
                return "text-info";
            case "2":
                return "text-primary";
            case "3":
                return "text-warning";
            case "4":
                return "text-success";
            case "5":
                return "text-danger";

            default:
                return "text-info";
        }
    },

    obter_credenciais_reembolso() {
      this.$refs.cred.abrir(this.marcacao);
    },

    log_guia (guia) {
      this.$util.logAudit('guia', guia.id_guia);
    },

    recalc_contrato (guia) {
      this.$util.atualizar(this, {
        service: 'guias',
        func: 'recalc_contrato',
        dados: {
            id_guia: guia.id_guia,
        },
        callback: () => {
          this.reload();
        },
        toast: true,
      });
    },

    lista_itens(guia) {
      if ( !guia.atendimento_procedimento_guias )
        return "";

      return guia.atendimento_procedimento_guias.filter(item => item.item_tabela)
        .map(item => item.item_tabela.st_nome
          + ( item.grau_participacao ? ' (' + item.grau_participacao.st_codigo_tiss + ')' : '' )
        )
        .join(', ');
    },

    autorizar_manual(guia) {
      this.$refs.aut_manual.abrir(guia);
    },

    reabrir(item) {
      let etapa = _.get(item, 'item_status.ultima_etapa.id_etapa_atendimento');

      this.$emit("reabrir", {
        ...item,
        ir_para_etapa: etapa > 2 ? 8 : etapa,
      });
    },

    regerar(guia = null) {
      if (
        !confirm(
          guia
            ? 'Confirma regerar a guia selecionada?'
            : "Confirma regerar as guias? Isso irá cancelar as guias e gerar novas."
        )
      )
        return;

      this.$util.atualizar(this, {
        service: "guias",
        func: "regerar",
        dados: {
          id_atendimento: this.marcacao.id_atendimento,
          id_guia: guia ? guia.id_guia : null,
        },
        callback: () => {
          this.reload();
        },
        toast: true,
      });
    },

    closeDispashModal() {
        this.$refs.dispatchModal.hide_modal();
        this.$store.commit('loading', false);
    },

    autorizar_guias() {
        if (!confirm("Deseja realizar a autorização online de procedimentos de todas as guias?")) {
            return;
        }

        this.$refs.autoriz.verificar_servico_online(this.marcacao.plano, () => {

            if (this.$refs.autoriz.tem_trilha(this.marcacao.plano, this.marcacao)) {
                // this.$toast.add({
                //         severity: "warn",
                //         summary: "Atenção",
                //         detail: "Não é possível autorizar em lote guias com trilha/token. Favor autorizar individualmente.",
                //         life: 3000
                //     });
                this.$refs.autoriz.clear();
                this.$refs.autoriz.abrir(() => {
                    this.$refs.dispatchModal.show_modal()

                  const guiasParaAutorizar = this.lista.filter(guia => guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS');

                  // Referência (execução paralela antiga)
                  // const ultimaGuia = this.lista.filter(guia => guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS').pop();
                  // this.lista.forEach((guia) => {
                  //   if (guia.ch_status == 'DI' || guia.ch_status == 'PR' || guia.ch_status == 'TS') {
                  //     this.$refs.autoriz.autorizar_guia(this.marcacao, guia,
                  //       false,
                  //       ultimaGuia.id_guia == guia.id_guia
                  //         ? () => this.closeDispashModal()
                  //         : () => { }
                  //     );
                  //   }
                  // });

                  guiasParaAutorizar
                    .reduce((promise, guia) => {
                      return promise.then(() => new Promise((resolve) => {
                        this.$refs.autoriz.autorizar_guia(this.marcacao, guia, false, () => resolve());
                      }));
                    }, Promise.resolve())
                    .then(() => this.closeDispashModal());
                });
                return;
            }

            this.$refs.dispatchModal.show_modal()

              const guiasParaAutorizar = this.lista.filter(guia => guia.ch_status == 'DI' || guia.ch_status == 'PR');

              // Referência (execução paralela antiga)
              // const ultimaGuia = this.lista.filter(guia => guia.ch_status == 'DI' || guia.ch_status == 'PR').pop();
              // this.lista.forEach((guia) => {
              //   if (guia.ch_status == 'DI' || guia.ch_status == 'PR') {
              //     this.$refs.autoriz.autorizar_guia(this.marcacao, guia,
              //       false,
              //       ultimaGuia.id_guia == guia.id_guia
              //         ? () => this.closeDispashModal()
              //         : () => { }
              //     );
              //   }
              // });

              guiasParaAutorizar
                .reduce((promise, guia) => {
                  return promise.then(() => new Promise((resolve) => {
                    this.$refs.autoriz.autorizar_guia(this.marcacao, guia, false, () => resolve());
                  }));
                }, Promise.resolve())
                .then(() => this.closeDispashModal());

        });

      //this.$refs.autoriz.autorizar_guia(this.marcacao, guia);
    },

    autorizar(guia) {
      this.$refs.autoriz.autorizar_guia(this.marcacao, guia);
    },

    autorizar_status(guia) {
      this.$refs.autoriz.consultar_online(guia.autorizacao, (res) => {
        console.log(res);
      });
    },

    autorizar_cancelar(guia) {
      this.$refs.autoriz.cancelar_online(guia.autorizacao, (res) => {
        console.log(res);
      });
    },

    autorizar_consultar(guia) {
      this.$refs.autoriz.consultar(guia.autorizacao);
    },

    autorizar_enviar_documentos(guia) {
      this.$refs.autoriz.enviar_documentos(guia.autorizacao);
    },

    cancelar_guia(guia) {
      this.validate = false;
      this.guia_a_cancelar = guia;
      this.motivo = "";
      this.definitivo = false;

      $("#cancelarGuiaModal").modal("show");
    },

    confirmar_cancelar_guia() {
      if ( this.definitivo ) {
        if ( !confirm('Confirma realizar o cancelamento definitivo da guia?') ) {
          return;
        }
      }

      this.$util.atualizar(this, {
        service: "guias",
        func: "solicitar_cancelamento",
        dados: {
          id_guia: this.guia_a_cancelar.id_guia,
          motivo: this.motivo,
          definitivo: this.definitivo,
        },
        modal: "cancelarGuiaModal",
        callback: () => {
          this.reload();
        }
      });
    },

    fechar_modal_cancelar_guia() {
      $("#cancelarGuiaModal").modal("hide");
    },

    reload() {
      this.$emit("refresh");
    },

    abrirModal() {
      this.print(true, null, () => {
        this.$refs.vis.inicializacao();
      });
    },
    imprimirConsulta() {
      this.print(true, null, () => {
        this.$refs.vis.imprimirConsulta();
      });
    },
    imprimirOutras(primeira_pagina = false, valor_total_geral = false, obter_callback = false) {
        let callback = () => {
          this.$refs.vis.imprimirOutras(null, primeira_pagina, valor_total_geral);
        };

        if ( obter_callback ) {
          return callback;
        }

        this.print(true, null, callback);
    },
    imprimirUnica(guia, primeira_pagina = false, valor_total_geral = false, obter_callback = false) {
        let callback = () => {
          if (guia && guia.ch_tipo_guia == 'C') {
            this.$refs.vis.imprimirConsulta(guia.id_guia);
          } else {
            this.$refs.vis.imprimirOutras(guia.id_guia, primeira_pagina, valor_total_geral);
          }
        };

        if ( obter_callback ) {
          return callback;
        }

        this.print(true, null, callback);
    },

    print(exibir = true, modal = null, callbackPrint = null) {
      const tipoGuias = _.map(this.lista, 'ch_tipo_guia');
      
      console.log(exibir, modal, callbackPrint, tipoGuias);

      if ( this.marcacao.plano.operadora.fl_servico_autorizacao ) {

        if ( this.marcacao.atendimento.guias.find(guia => ( guia.ch_status == 'DI' || guia.ch_status == 'PR' )
          && !guia.autorizacao && guia.atendimento_procedimento_guias.length )
        ) {

          if (this.marcacao.plano.operadora.fl_autoriz_obrig) {
            this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Autorização On-line não realizada.",
                life: 3000
            });
            return;
          }

          if ( !confirm('Autorização On-line não realizada. Deseja prosseguir mesmo assim?') ) {
            return;
          }

        }

      }

      //

      if ( exibir ) { 

        if ( this.guia_operadora && this.guia_operadora.ch_imp_guia == 'N' && this.lista && this.lista.length > 0 ) { 
            
            if ( !this.pode_imp_guias ) { 
                this.$toast.add({ 
                    severity: "warn",
                    summary: "Atenção",
                    detail: "A operadora não exige a impressão da guia.",
                    life: 5000 
                })
                return;
            }

            if ( !confirm('A operadora não exige a impressão da guia. Deseja prosseguir mesmo assim?') ) { 
                return;
            }

        } else if ( this.guia_operadora && this.guia_operadora.ch_imp_guia == '1' && this.lista && this.lista.length > 0 ) { 

            if ( !this.pode_imp_guias ) { 
                callbackPrint = this.imprimir_guia_pagina_total(true);
            } else { 
                if ( confirm('Impressão da guia SOMENTE DA PRIMEIRA PÁGINA (TOTAL) para essa operadora. Confirma?') ) { 
                    callbackPrint = this.imprimir_guia_pagina_total(true);
                }
            }

        } else if ( this.guia_operadora && this.guia_operadora.ch_imp_guia == 'P' && this.lista && this.lista.length > 0 ) { 

            if ( !this.pode_imp_guias ) { 
                callbackPrint = this.imprimir_guias_pagina(true);
            } else { 
                if ( confirm('Impressão da guia SOMENTE DA PRIMEIRA PÁGINA para essa operadora. Confirma?') ) { 
                    callbackPrint = this.imprimir_guias_pagina(true);
                }
            }

        }

      }

      //

      this.$util.atualizar(this, {
        service: "guias",
        func: "set_numero_atribuido",
        dados: {
          guias: this.lista,
          id_atendimento: this.marcacao.atendimento.id_atendimento,
          fl_reembolso: this.marcacao.atendimento.fl_reembolso,
          pagamento_atendimento: this.marcacao.atendimento.pagamento_atendimento,
          imprimindo: exibir,  
          outras: this.marcacao.outras 
            ? this.marcacao.outras.filter(item => item.id_atendimento)
                .map(item => item.id_atendimento) 
            : [],
        },
        callback: pa => {
          if ( pa ) {
            this.$emit('atualizar_progresso', pa);
          }

          this.$nextTick(() => {

            // Se for BPA ou Apac, Gerar o pdf no Back e não no Front
            if (tipoGuias.includes('B') || tipoGuias.includes('A')) {

              if (!exibir) $("#" + modal).modal("hide");
              else {
                  this.$util.atualizar(this, {
                      service: "guias",
                      func: "gerar_guia_sus",
                      dados: {
                          guias: _.map(this.lista, 'id_guia')
                      },
                      callback: res => {
                          let pdfWindow = window.open("");
                          pdfWindow.document.write(
                              "<html><head><title>" + 
                                  "SOLICITAÇÃO DE EXAME OU PROCEDIMENTO</title></head><body><iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                                  encodeURI(res.pdf) +
                                  "'></iframe></body></html>"
                          );
                      }
                  });
              }
              
              return;
            } else { 

              if (!exibir) $("#" + modal).modal("hide");
              else {
                  this.atualizar_json_guias(() => {
                      if(callbackPrint)
                          callbackPrint();
                      else
                          this.$refs.vis.inicializacao();
                  });
              }

            }
          });
        }
      });

    },

    atualizar_json_guias(callback = null) {
        const guias = _.map(this.lista, 'id_guia');

        this.$util.atualizar(this, {
        service: "guias",
        func: "atualizar_json_guias",
        dados: {
          guias: guias,
        },
        callback: res => {
          if ( res ) {
            this.guias = res;
          }

          this.$nextTick(() => {
            if (callback) callback();
          });
        }
      });

    },


    pendencia(guia) {
      this.guia_selecionada = guia;
      this.$refs.motivoglosa.abrir([guia]);
    },

    solucionar(guia) {
      this.guia_selecionada = guia;
      this.$refs.motivoglosa.solucionar([guia]);
    },

    getGuias() {
      if (
        !this.marcacao ||
        !this.marcacao.atendimento ||
        !this.marcacao.atendimento.guias ||
        !this.marcacao.plano
      )
        return;

      this.tem_reembolso = (
        this.marcacao.atendimento.fl_reembolso
        || this.marcacao.atendimento.guias.find(guia => guia.ch_status != 'CA'
              && guia.contrato_operadora
              && guia.contrato_operadora.fl_reembolso)
      );

      console.log('recarregando guias');

      this.guias = [];
      let query = {
        q: [
          {
            name: "operadoras.show",
            id: "operadora",
            parms: {
              id: this.marcacao.plano.id_operadora,
              with: ["logo.arquivo", "guiaOperadora"]
            }
          }
        ]
      };

      this.marcacao.atendimento.guias.forEach((item, idx) => {
        query.q.push({
          name: "tiss.gerar_json",
          id: "guia." + idx,
          parms: {
            id: item.id_guia
          }
        });
      });

      query.q.push({
        name: "operadoras.verificar_unificar_guias",
        id: "verificar_unificar",
        parms: {
          id_operadora: this.marcacao.plano.id_operadora,
        }
      });

      query.q.push({
        name: "configuracoes.index",
        id: "config_nome_ass",
        parms: {
          where: {
            st_slug: 'nome-contratado-ass',
            st_valor: '1',
          }
        }
      });

      query.q.push({
        name: "configuracoes.index",
        id: "config_prazo",
        parms: {
          where: {
            st_slug: 'espelho-exibir-prazo',
            st_valor: '1',
          }
        }
      });

      query.q.push({
        name: "configuracoes.index",
        id: "config_docs_sem_login",
        parms: {
          where: {
            st_slug: 'recepcao-block-docs-sem-login',
            st_valor: '1',
          }
        }
      });


      this.axios.post("/aql?a=tiss.gerar_json", query).then(res => {
        this.logo_url = res.data.operadora.data.logo
          ? res.data.operadora.data.logo.arquivo.temporary_url
          : "";

        this.nome_contratado_ass = res.data.config_nome_ass.data && res.data.config_nome_ass.data.length;
        this.exibir_prazo = res.data.config_prazo.data && res.data.config_prazo.data.length;
        this.docs_sem_login = res.data.config_docs_sem_login.data && res.data.config_docs_sem_login.data.length;

        this.guia_operadora = res.data.operadora.data.guia_operadora;

        this.marcacao.atendimento.guias.forEach((item, idx) => {
          if (res.data["guia." + idx].status == 200) {
            this.guias.push(res.data["guia." + idx].data);
          }
        });

        this.unificar = _.get(res, 'data.verificar_unificar.data.unificar')

        this.pode_imp_guias = _.get(res, 'data.verificar_unificar.data.pode_imp_guias') === false ? false : true;
      });
    },

    imprimirBpa(guia) {
      console.log(guia)
      this.$util.print_preview("imprimir/bpa/" + guia.id_guia);
    },

    log_autorizacoes(guia) {
        this.$refs.logSolicAutorizacao.abrir_modal(guia.autorizacao);
    }
  },
  watch: {
    marcacao: function() {
      this.$nextTick(this.getGuias());
    }
  },
  mounted() {
    this.espelho_sem_valor = this.$util.getCookie('esv') == 'N' ? true : false;
    this.espelho_detalhe_despesa = this.$util.getCookie('esd') == 'S' ? true : false;

    this.getGuias();
  }
};
</script>